import React from 'react'

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

interface Props extends SvgIconProps {
  filled?: boolean
}

const pathOutlined =
  'M8.698 8.178a3.125 3.125 0 1 1 3.604 0c1.347.688 2.198 2.112 2.198 3.572v.5h-8v-.5c0-1.46.85' +
  '1-2.884 2.198-3.572zM3 3V1a1 1 0 0 1 1-1h13a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-2v2a1 1 0 0 1-1 ' +
  '1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2zm0 1H1v13h13v-2H4a1 1 0 0 1-1-1V4zm1-3v13h13V1H4zm6.5 6.' +
  '75a2.125 2.125 0 1 0 0-4.25 2.125 2.125 0 0 0 0 4.25zm2.955 3.5c-.237-1.328-1.397-2.5-2.955-' +
  '2.5s-2.718 1.172-2.955 2.5h5.91z'

const pathFilled =
  'M8.698 8.178C7.35 8.866 6.5 10.29 6.5 11.75v.5h8v-.5c0-1.46-.851-2.884-2.198-3.572a3.125 3.1' +
  '25 0 1 0-3.604 0zM15 15v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2V1a1 1 0 0 1 1-1h13' +
  'a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-2zM3 4H1v13h13v-2H4a1 1 0 0 1-1-1V4z'

const FriendsIcon: React.SFC<Props> = ({ filled, ...props }) => (
  <SvgIcon {...props} viewBox="-2 -2 22 22">
    <path d={filled ? pathFilled : pathOutlined} />
  </SvgIcon>
)

export default FriendsIcon
